module.exports = __webpack_public_path__ + "static/media/warning.4d303963.png";